import styles from './StatusTag.module.css'
import type { StatusTagProps } from '../types'

export function StatusTag({ children, variant = 'default' }: StatusTagProps) {
  return <span className={`${styles.tag} ${styles[variant]}`}>{children}</span>
}
